import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';

import { useTranslation } from 'react-i18next';

const CardEditMenu = ({ event, delEvent, settings, showEditingModal }) => {
  const { t, i18n } = useTranslation();

  return (
    <div>
      <div class='flex justify-start'>
        {/* отображаем меню редактирования */}
        <div className='tabs'>
          {!settings.noEdit && (
            <a className='tab tab-sm' onClick={() => showEditingModal(true)}>
              {t('edit')}
            </a>
          )}
          {!settings.noDelete && (
            <a className='tab tab-sm' onClick={() => delEvent(event)}>
              {t('delete')}
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default CardEditMenu;
